// extracted by mini-css-extract-plugin
export default {"container":"XjCN_","cards-list":"Ftlga","title":"KGu9c","button":"U2TmY"};